import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const YogaPieChartGraph = ({ obj }: any) => {
  const [data, setData] = useState<any>([]);
  function convertActivityToArray(activity: any) {
    const result = [];

    for (const [key, value] of Object.entries(activity)) {
      let name = "";
      let color = "";
      switch (key) {
        case "COMPLETED":
          name = `No. of sessions completed (${value})`;
          color = "green";
          break;
        case "RESCHEDULED":
          name = `No. of sessions rescheduled (${value})`;
          color = "#418ed6";
          break;
        case "CANCELLED":
          name = `No. of sessions cancelled (${value})`;
          color = "red";
          break;
        case "HOLIDAY":
          name = `No. of holidays (${value})`;
          color = "teal";
          break;
        case "CANCELLED_BY_SPOC":
          name = `No. of sessions cancelled by SPOC (${value})`;
          color = "orange";
          break;
        case "CANCELLED_BY_EXPERT":
          name = `No. of sessions cancelled by expert (${value})`;
          color = "purple";
          break;
        case "":
          name = `No. of sessions with no status (${value})`;
          color = "black";
          break;
      }
      result.push({ name, value: value as number, color });
    }
    setData(result);
  }

  const isNoData = data.every((entry: any) => entry.value === 0);

  // const COLORS = ["green", "#418ed6", "red"];
  useEffect(() => {
    convertActivityToArray(obj);
  }, [obj]);

  return (
    <div style={{ width: "100%", height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={isNoData ? [{ name: "No Data", value: 100 }] : data}
            labelLine={false}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {isNoData ? (
              <Cell key={`cell-no-data`} fill="#d9d9d9" />
            ) : (
              data.map((entry: any, index: any) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))
            )}
          </Pie>
          {!isNoData && <Tooltip />}
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default YogaPieChartGraph;
